import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Chart from 'chart.js/auto';
import Dashboard from './Dashboard';
import Login from './Login';
import Register from './Register'; // Import Register component
// Other imports

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js');  // For offline
    }
  }, []);

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route path="/register" element={<Register />} /> {/* New Register route */}
        <Route path="/dashboard" element={token ? <Dashboard token={token} /> : <Navigate to="/login" />} />
        <Route path="/" element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        {/* Other routes: /accounts, /budgets, /reports */}
      </Routes>
    </>
  );
}

export default App;
//ss